import { Button } from '@material-ui/core';
import React from 'react';
import { RemoveButtonProps } from './interfaces';

const RemoveButton = ({
  label,
  disabled = false,
  onClick,
}: RemoveButtonProps): JSX.Element => {
  return (
    <Button
      disabled={disabled}
      variant="contained"
      color="primary"
      onClick={onClick}
    >
      {label || 'Remover'}
    </Button>
  );
};

export default RemoveButton;
